import { Typography, Card, CardContent, CardHeader, useTheme } from '@mui/material';
import NotificationsNews from './components/NotificationsNews';
import { useTranslation } from 'react-i18next';

const Notifications = (props: { storeNumber: string | undefined }) => {

  const { t } = useTranslation('common');
  const theme = useTheme();


  return (
    <Card sx={{
      background: theme.palette.common.white,
      borderRadius: '12px',
      border: `1px solid ${theme.palette.custom.gray[200]}`,
      boxShadow: theme.shadows[1],
    }}>
      <CardHeader sx={{ p: '24px', pb: '16px', textAlign: 'left' }}
        title={
          <Typography
            variant='textLG'
            sx={{
              fontWeight: 700,
              color: theme.palette.custom.gray[900],
            }}
          >
            {t('notificationNewsTab')}
          </Typography>
        }
      />
      <CardContent sx={{ px: '24px', paddingBottom: '24px', maxHeight: '500px', overflowY: 'auto' }}>
        <NotificationsNews storeNumber={props?.storeNumber} />
      </CardContent>
    </Card>
  );
};

export default Notifications;